import React from 'react';
import { Modal, StyleSheet } from "react-native"
import { View } from '../../../src/Components/Themed';
import { ProfileManager } from 'be-components';
import type { MyPlayerProps } from '../../../src/types';

type ProfileHolder = {
    me:MyPlayerProps,
    walkthrough?: { level:'verify' | 'basic' }
    show_welcome?:boolean,
    visible:boolean,
    insets:{ top:number, bottom:number, left:number, right:number }
    mode: 'desktop'|'mobile',
    onClose: () => void,
    onLogout: () => void
}

const ProfileHolder = ({ me, insets, show_welcome, walkthrough, mode, visible, onClose, onLogout } : ProfileHolder) => {
    
    return (
        <Modal
            style={styles.modalContainer}
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            transparent
            visible={visible}
        >
            <View type="blur" style={mode=='desktop' ? styles.desktopContainer : { ...styles.viewContainer}}>
                <View float style={mode=='desktop' ?{ flex:1, width:500, maxHeight:750, marginTop:insets.top, marginBottom:insets.bottom, borderRadius:22 }:{ flex:1, marginTop:10 + insets.top, marginBottom:10+insets.bottom, marginLeft:10+insets.left, marginRight:10+insets.right }}>
                    <ProfileManager
                        player={me}
                        float
                        insets={insets}
                        view_mode={mode}
                        style={{ borderRadius:8 }}
                        onClose={() => onClose()}
                        onLogout={() => onLogout()}
                        keyboard_height={0}
                        show_welcome={show_welcome}
                        onRedeemCode={(cd) => console.log(cd)}
                        hide_powered_by
                        walkthrough={walkthrough}
                        onNextStep={(step) => console.log(step)}
                        onPlayerUpdate={(p, attribute) => console.log('player updated!!!')}
                        onVouchStart={() => console.log('vouch')}
                        //width={}
                    />
                </View>
            </View>

        </Modal>
    )
}

const styles = StyleSheet.create({
    modalContainer: { flex:1 },
    viewContainer: { flex:1, justifyContent:'flex-end', zIndex:20 },
    desktopContainer:{ flex:1, justifyContent:'center', alignItems:'center' }
})

export default ProfileHolder